/* eslint-disable space-before-function-paren */
/* eslint-disable indent */
import LocationApi from '@/controllers/LocationApi'
import AuthApi from '@/controllers/AuthApis'
import { locationUrl, authUrl } from '@/env'

import * as types from '@/store/mutation-types'

export default {
    async GetAllLocations({ commit }, value) {
        const url = `${authUrl}/api/v1/locations/users/me?withAddress=true`
        const params = {
            // page: value.page ? value.page : 1,
            // limit: value.limit ? value.limit : 50,
            // withContactDetails: value.withContactDetails ? value.withContactDetails : false,
            withAddress: value.withAddress ? value.withAddress : false
        }
        await AuthApi.getApi(url, params).then(response => {
            commit(types.SET_ALL_LOCATIONS, response.data.payload)
        })
    },
    async CreateLocations({ commit }, data) {
        const url = `${locationUrl}/locations`
        await LocationApi.postApi(url, data)
            .then(response => {
                commit(types.SET_LOCATION, response.data.payload)
            })
    },

    async UpdateLocation({ commit }, { data, id }) {
        const url = `${locationUrl}/locations/${id}`
        await LocationApi.patchApi(url, data)
            .then(response => {
                // commit(types.SET_LOCATION, response.data.payload)
            })
    },

    async AddAddressToLocation({ commit, rootGetters }, data) {
        const url = `${locationUrl}/locations/${rootGetters['locations/location'].id}/addresses`
        await LocationApi.postApi(url, data)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async GetAddressOfLocation({ commit, rootGetters }) {
        const url = `${locationUrl}/locations/${rootGetters['locations/location'].id}/addresses`
        await LocationApi.getApi(url)
            .then(response => {
                commit(types.SET_LOCATION_ADDRESS, response.data.payload)
            })
    },

    async UpdateLocationAddress({ commit, rootGetters }, data) {
        const url = `${locationUrl}/locations/${rootGetters['locations/location'].id}/addresses`
        await LocationApi.postApi(url, data)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async DeleteLocation({ }, { locationId }) {
        const url = `${locationUrl}/locations/${locationId}`
        await LocationApi.deleteApi(url)
    },

    // Actions for Location Groups
    async GetAllLocationGroups({ commit }) {
        const url = `${locationUrl}/groups`
        await LocationApi.getApi(url)
            .then(response => {
                commit(types.SET_LOCATION_GROUPS, response.data.payload)
            })
    },

    async CreateLocationGroup({ commit }, data) {
        const url = `${locationUrl}/groups`
        await LocationApi.postApi(url, data)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async UpdateLocationGroup({ commit }, { data, id }) {
        const url = `${locationUrl}/groups/${id}`
        await LocationApi.patchApi(url, data)
        // .then(response => {
        //     console.log(response.data.payload)
        //     // commit(types.SET_LOCATION, response.data.payload)
        // })
    },

    async AddLocationToGroup({ commit }, value) {
        const url = `${locationUrl}/groups/${value.groupId}/locations`
        await LocationApi.postApi(url, value.data)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async GetLocationGroupWithLocations({ commit }, id) {
        const url = `${locationUrl}/groups/${id}?withLocations=true`
        await LocationApi.getApi(url)
            .then(response => {
                commit(types.SET_LOCATION_GROUP_WITH_LOCATION, response.data.payload)
            })
    },

    async GetUsersOfBusiness({ commit }, id) {
        const url = `${locationUrl}/users`
        await LocationApi.getApi(url)
            .then(response => {
                commit(types.SET_BUSINESS_USERS, response.data.payload)
            })
    },

    async AddUsersToLocation({ }, value) {
        const url = `${locationUrl}/locations/${value.locationId}/users`
        await LocationApi.postApi(url, value.data)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async SearchLocations({ commit }, searchTerm) {
        const url = `${locationUrl}/locations/search?term=${searchTerm}`
        let response = await LocationApi.getApi(url)
        commit(types.SET_SEARCHED_LOCATIONS, response.data.payload)
        return response.data.payload
    }

}
